var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('Col',{attrs:{"xs":12,"s":4,"l":3,"hasMargin":""}},[_c('Link',{attrs:{"onClick":() => _vm.onLinkClick(_vm.$t('profile.legal.form.privacyStatement')),"to":_vm.ROUTE_PRIVACY,"weight":"regular","external":""}},[_vm._v(" "+_vm._s(_vm.$t('profile.legal.form.privacyStatement'))+" ")])],1),_c('Col',{attrs:{"xs":12,"s":8,"l":9,"hasMargin":""}},[_c('span',{domProps:{"innerHTML":_vm._s(
          _vm.$t('profile.legal.privacyStatement.accepted', {
            date: _vm.formatDate(this.user.privacyStatementAcceptedOn),
          })
        )}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }